<template>
<!--    <button-->
<!--        class="def-subscribe"-->
<!--        type="button"-->
<!--        @click="openModal"-->
<!--    >-->
<!--        <svg class="def-subscribe__icon">-->
<!--            <use xlink:href="#svg-message"></use>-->
<!--        </svg>-->
<!--        Підписатись-->
<!--    </button>-->
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'DefSubscribe',
    props: ['result'],
    computed: {
        ...mapState({
            subscribeData: ({ results }) => results?.subscribe?.data,
            messages: ({ results }) => results?.subscribe?.messages,
        })
    },
    methods: {
        showModal() {
            this.$DefModal.show({
                name: 'ShoppingPresent',
                width: '1200px',
                padding: false,
                // props: {
                //     padding: false,
                // }
            });
        },
        openModal() {
            try {
                const subscribeId = this?.subscribeData?.id;
                if (subscribeId) {
                    const isSubscribeModalWasShown = window.sessionStorage.getItem(`isSubscribeModal${subscribeId}WasShown`);
                    if (!isSubscribeModalWasShown) {
                        setTimeout(() => {
                            this.showModal();
                        }, this.subscribeData.timeout * 1000);
                    }
                }

            } catch (err) {
                console.error(err);
            }
        }
    },
    mounted() {
        if (this.subscribeData) {
            this.openModal();
        }
    }
}
</script>

<style lang="scss" scoped>
//.def-subscribe{
//    display: flex;
//    align-items: center;
//    justify-content: center;
//    background-color: transparent;
//    border: 1px solid #fff;
//    height: 44px;
//    padding: 0 15px;
//    color: #fff;
//    &__icon{
//        display: block;
//        width: 16px;
//        height: 16px;
//        fill: #fff;
//        margin-right: 8px;
//    }
//}
</style>